import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Alert,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import { findSelectedProperty, getDefaultSelectedPropertyId } from '../../../platform/propertyScope';
import { fetchProperties } from '../../../store/core/companySlice';
import { canViewRoomRevenueKpiBasis, isModuleEnabled } from '../utils/permissions';
import RoomRevenueKPIBasisManager from '../RoomRevenueKPIBasisManager';
import AsyncState from '../../../components/ui/AsyncState';
import SectionCard from '../../../components/ui/SectionCard';

export default function FinancePage() {
  const dispatch = useDispatch();
  const { properties, status } = useSelector((state) => state.company);
  const currentUser = useSelector((state) => state.user.user);
  const [selectedPropertyId, setSelectedPropertyId] = useState('');
  const canViewFinance = canViewRoomRevenueKpiBasis(currentUser) && isModuleEnabled(currentUser, 'finance');

  useEffect(() => {
    if (status === 'idle') dispatch(fetchProperties());
  }, [dispatch, status]);

  useEffect(() => {
    const defaultPropertyId = getDefaultSelectedPropertyId(properties);
    if (!selectedPropertyId && defaultPropertyId) {
      setSelectedPropertyId(defaultPropertyId);
    }
  }, [properties, selectedPropertyId]);

  const selectedProperty = findSelectedProperty(properties, selectedPropertyId);

  if (!canViewFinance) {
    return <Alert severity="warning">Non hai accesso al modulo Finance.</Alert>;
  }

  if (status === 'loading' && properties.length === 0) {
    return <AsyncState state="loading" message="Caricamento configurazione Finance" fullWidth />;
  }

  return (
    <Stack spacing={3}>
      <SectionCard
        eyebrow="Finance configuration"
        title="Configurazione KPI e Revenue"
        description="Definisci le basi di calcolo della property attiva per KPI, room revenue e reporting operativo."
        sx={{ p: 3 }}
      >
        <FormControl fullWidth size="small" sx={{ maxWidth: 480 }}>
          <InputLabel id="finance-property-label">Property</InputLabel>
          <Select
            labelId="finance-property-label"
            value={selectedPropertyId}
            label="Property"
            onChange={(event) => setSelectedPropertyId(event.target.value)}
          >
            {properties.map((property) => (
              <MenuItem key={property.id} value={property.id}>
                {property.name} ({property.code})
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </SectionCard>

      <RoomRevenueKPIBasisManager selectedPropertyId={selectedProperty?.id || selectedPropertyId} />
    </Stack>
  );
}